var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAsync(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 50)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "0;45",
    keyTimes: "0;1",
    dur: "0.23809523809523808s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.58039891549808 -5 L37.58039891549808 -5 L37.58039891549808 5 L29.58039891549808 5 A30 30 0 0 1 24.452034569284628 17.38096675741915 L24.452034569284628 17.38096675741915 L30.108888818777007 23.03782100691153 L23.037821006911532 30.108888818777007 L17.380966757419152 24.452034569284628 A30 30 0 0 1 5.000000000000001 29.58039891549808 L5.000000000000001 29.58039891549808 L5.000000000000002 37.58039891549808 L-4.9999999999999964 37.58039891549808 L-4.999999999999997 29.58039891549808 A30 30 0 0 1 -17.38096675741915 24.452034569284628 L-17.38096675741915 24.452034569284628 L-23.03782100691153 30.108888818777007 L-30.108888818777004 23.037821006911532 L-24.452034569284624 17.380966757419152 A30 30 0 0 1 -29.58039891549808 5.000000000000002 L-29.58039891549808 5.000000000000002 L-37.58039891549808 5.000000000000003 L-37.58039891549808 -4.999999999999995 L-29.58039891549808 -4.999999999999996 A30 30 0 0 1 -24.45203456928463 -17.38096675741915 L-24.45203456928463 -17.38096675741915 L-30.10888881877701 -23.03782100691153 L-23.037821006911525 -30.10888881877701 L-17.380966757419145 -24.45203456928463 A30 30 0 0 1 -5.000000000000017 -29.580398915498076 L-5.000000000000017 -29.580398915498076 L-5.000000000000019 -37.58039891549808 L5.000000000000004 -37.58039891549808 L5.000000000000006 -29.58039891549808 A30 30 0 0 1 17.380966757419138 -24.452034569284635 L17.380966757419138 -24.452034569284635 L23.037821006911518 -30.108888818777018 L30.10888881877701 -23.03782100691153 L24.45203456928463 -17.380966757419145 A30 30 0 0 1 29.580398915498076 -5.0000000000000195 M0 -20A20 20 0 1 0 0 20 A20 20 0 1 0 0 -20",
    fill: "#75bf43"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsync);
export default __webpack_public_path__ + "static/media/async.1c17f5dafc0b4f517c8d6b87d7a8ce8f.svg";
export { ForwardRef as ReactComponent };